import script from "./page-header.vue?vue&type=script&setup=true&lang=ts"
export * from "./page-header.vue?vue&type=script&setup=true&lang=ts"

const cssModules = {}
import style0 from "./page-header.vue?vue&type=style&index=0&id=5c64dea1&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__